const ANNOTATIONS_URL = '/services/plugin-annotations/annotations'
const fetchDefaults = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json'
    }
}

export function deleteAnnotation (event) {
    const url = `${ANNOTATIONS_URL}/${event.uid}`

    return fetch(url, {
        ...fetchDefaults,
        method: 'DELETE'
    }).then(defaultHandler)
}

// helper fns
const defaultHandler = response => {
    if (!response.ok) throw response

    return response
}
